import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { styles } from "./styles";

type TutorialModalProps = {
  open: boolean;
  name: string;
  link?: string;
  onClose: () => void;
};

const TutorialModal = ({ open, name, link, onClose }: TutorialModalProps) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      scroll="paper"
      onClose={onClose}
      sx={styles.container}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="outputs-modal-title">
        <Typography variant="h6">{name}</Typography>
      </DialogTitle>

      <DialogContent id="outputs-modal-content">
        <Box sx={styles.playerWrap}>
          <iframe
            src={`https://www.youtube.com/embed/${link}`}
            style={{
              // position: "absolute",
              top: 0,
              left: 0,
              height: "60vh",
              width: "100%",
              border: 0,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={styles.actions} id="outputs-modal-actions">
        <Button
          href="mailto:support@preimage.ai"
          startIcon={<EmailOutlinedIcon />}
          color="inherit"
        >
          Support
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TutorialModal;
